import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { AuthenticationEnvironment } from '@warema/shared/models';
import { OAuthStorage, provideOAuthClient } from 'angular-oauth2-oidc';
import { AuthenticationApiBrowserService } from './authentication-api.browser.service';
import { AuthenticationApiServerService } from './authentication-api.server.service';
import { AuthenticationApiService } from './authentication-api.service';

// We need a factory, since localStorage is not available during AOT build time.
export function storageFactory(): OAuthStorage {
    return localStorage;
}

export function provideAuthentication(environment: AuthenticationEnvironment): EnvironmentProviders {
    return makeEnvironmentProviders([
        provideOAuthClient({
            resourceServer: {
                allowedUrls: environment.authenticatedUrls,
                // in case we have URLs, which we want to skip authentication for, we override the default URL validation and explicitly skip authentication for those URLs
                // all other URLs are validated against the authenticated URLs list
                customUrlValidation:
                    environment.skipAuthenticatedUrls?.length > 0
                        ? (url: string): boolean => {
                              if (
                                  environment.skipAuthenticatedUrls.some(u =>
                                      url.toLowerCase().startsWith(u.toLowerCase()),
                                  )
                              ) {
                                  return false;
                              }

                              return !!environment.authenticatedUrls.some(u =>
                                  url.toLowerCase().startsWith(u.toLowerCase()),
                              );
                          }
                        : undefined,
                sendAccessToken: true,
            },
        }),
        { provide: OAuthStorage, useFactory: storageFactory },
        { provide: AuthenticationApiService, useClass: AuthenticationApiBrowserService },
    ]);
}

export function provideAuthenticationServer(): EnvironmentProviders {
    return makeEnvironmentProviders([{ provide: AuthenticationApiService, useClass: AuthenticationApiServerService }]);
}
